










































import { Component, Mixins, Prop } from 'vue-property-decorator'
import FocusTrap from 'library/v4/components/FocusTrap.vue'

@Component({ components: { FocusTrap } })
export default class OzOverlay extends Mixins() {
  /**
   * Selects type of scrim. If none is selected, elements covered by the overlay will be fully visible.
   */
  @Prop({ default: 'modal' }) scrim!: 'modal' | 'popover' | null

  /**
   * Dark mode. This has no effect if scrim is turned off.
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Fade the overlay and its contents in. Turn this off if you are showing a series of modals.
   */
  @Prop({ default: true }) shouldFadeIn!: boolean

  scrimClick(): void {
    /**
     * Emitted when user clicks or taps anywhere not occupied by the overlaid content.
     */
    this.$emit('scrim-click')
  }

  scrimEsc(): void {
    /**
     * Emitted when an escape keydown event is propagated to the overlay.
     * Since focus is trapped, it is effectively a global listener.
     */
    this.$emit('scrim-esc')
  }
}
